import { Routes, Route } from 'react-router-dom';
import { Index } from './pages/Index';
import { Photography } from './pages/Photography';
import { LinearAlgebra } from './pages/LinearAlgebra';
import { ProbStats } from './pages/ProbStats';
import { MachineLearning } from './pages/MachineLearning';
import { ReinforcementLearning } from './pages/ReinforcementLearning';
import { Diffusion } from './pages/Diffusion';
import { MechanicsControl } from './pages/MechanicsControl';
import { PyTorch } from './pages/PyTorch';
import { Gpu } from './pages/Gpu';
import { Rust } from './pages/Rust';
import { Python } from './pages/Python';
import { Wireless } from './pages/Wireless';
import { Tls } from './pages/Tls';
import { Crypto } from './pages/Crypto';
import { C } from './pages/C';
import { pages } from './data/pages';

const routes = {
  ph: Photography,
  la: LinearAlgebra,
  ps: ProbStats,
  ml: MachineLearning,
  rl: ReinforcementLearning,
  df: Diffusion,
  mc: MechanicsControl,
  pt: PyTorch,
  gpu: Gpu,
  rs: Rust,
  py: Python,
  wl: Wireless,
  tls: Tls,
  crypto: Crypto,
  c: C,
};

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      {pages.map((p) => {
        const Component = routes[p.slug];
        if (!Component) return null;
        return <Route key={p.slug} path={`/${p.slug}`} element={<Component />} />;
      })}
      <Route path="*" element={<Index />} />
    </Routes>
  );
}
